import { fireEvent } from '../index';
import { ProfileEvents } from './events';
import Modules from '../modules';

export const trackProfileEdit = (clientName: string) => {
  fireEvent(ProfileEvents.PROFILE_EDIT, { tenant_name: clientName, moduleName: Modules.Session });
};

export const trackProfileFeedback = (clientName: string) => {
  fireEvent(ProfileEvents.PROFILE_FEEDBACK, {
    tenant_name: clientName,
    moduleName: Modules.Session,
  });
};

export const trackProfileSignOut = (email?: string, clientName?: string) => {
  fireEvent(ProfileEvents.PROFILE_SIGN_OUT, {
    email,
    tenant_name: clientName,
    moduleName: Modules.Session,
  });
};
